import React, { useEffect } from "react";
import { useSelectTagContext } from "../../context/SelectTagContext";

function SelectTag({ label, options, fieldName }) {
  const { selectedFilters, setSelectedFilters } = useSelectTagContext();

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [fieldName]: newValue,
    }));
  };

  const isInvalid = !selectedFilters[fieldName];
  // useEffect(() => {
  //   console.log("--> Selected Filters:", selectedFilters);
  // }, [selectedFilters]);

  return (
    <>
      <label>{label}</label>
      <select
        style={{
          width: "100%",
          padding: "6px 12px",
          border: isInvalid ? "1px solid #e24a4a" : "1px solid #dAdAdA",
          borderRadius: "25px",
          backgroundColor: "white",
          fontSize: "15px",
          cursor: "pointer",
        }}
        value={selectedFilters[fieldName] || ""}
        onChange={handleInputChange}
        required
      >
        <option value="" disabled>
          Select
        </option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    </>
  );
}

export default SelectTag;
